import React from 'react';
import IconBase from './Icon-base';
export default class ZoomOut extends React.Component {
    render() {
        return (
            <IconBase width="30" height="30" viewBox="0 0 30 30" {...this.props}>
                <g id="Canvas_zo" transform="translate(258 235)">
                    <g id="Group 2_zo">
                        <g id="Ellipse 2_zo">
                            <mask id="mask0_outline_ins_zo">
                                <use
                                    xlinkHref="#path0_fill_zo"
                                    fill="white"
                                    transform="translate(-258 -235)"
                                />
                            </mask>
                            <g mask="url(#mask0_outline_ins_zo)">
                                <use
                                    xlinkHref="#path1_stroke_2x_zo"
                                    transform="translate(-258 -235)"
                                    fill="#4F5056"
                                />
                            </g>
                        </g>
                        <g id="Rectangle 3.1_zo">
                            <use
                                xlinkHref="#path2_fill_zo"
                                transform="translate(-251 -221)"
                                fill="#4F5056"
                            />
                        </g>
                    </g>
                </g>
                <defs>
                    <path
                        id="path0_fill_zo"
                        d="M 30 15C 30 23.2843 23.2843 30 15 30C 6.71573 30 0 23.2843 0 15C 0 6.71573 6.71573 0 15 0C 23.2843 0 30 6.71573 30 15Z"
                    />
                    <path
                        id="path1_stroke_2x_zo"
                        d="M 29 15C 29 22.732 22.732 29 15 29L 15 31C 23.8366 31 31 23.8366 31 15L 29 15ZM 15 29C 7.26801 29 1 22.732 1 15L -1 15C -1 23.8366 6.16344 31 15 31L 15 29ZM 1 15C 1 7.26801 7.26801 1 15 1L 15 -1C 6.16344 -1 -1 6.16344 -1 15L 1 15ZM 15 1C 22.732 1 29 7.26801 29 15L 31 15C 31 6.16344 23.8366 -1 15 -1L 15 1Z"
                    />
                    <path id="path2_fill_zo" d="M 0 0L 16 0L 16 2L 0 2L 0 0Z" />
                </defs>
            </IconBase>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/DocumentViewer/src/SVGIcons/ZoomOut.js